module.exports = __webpack_public_path__ + "static/media/ChainBridgeAPI.d.ts.257d1b47.map";